import asyncActionTypes from '../actions/types.js';

const initialState = {
  emdVoucherCompensation: false,
  loadingEmdVoucherCompensation: false,
  isEligibleEmd: false,
};

const emdVoucherCompensation = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.MANAGE_RETRIEVE_EMD_VOUCHER_COMPENSATION.START:
      return {
        ...state,
        loadingEmdVoucherCompensation: true,
      };
    case asyncActionTypes.MANAGE_RETRIEVE_EMD_VOUCHER_COMPENSATION.SUCCESS:
      return {
        ...state,
        loadingEmdVoucherCompensation: false,
        emdVoucherCompensation: action.payload.response,
        isEligibleEmd: true,
      };
    case asyncActionTypes.MANAGE_RETRIEVE_EMD_VOUCHER_COMPENSATION.FAIL:
      return {
        ...state,
        loadingEmdVoucherCompensation: false,
      };
    default:
      return state;
  }
};

export default emdVoucherCompensation;
